import { render, staticRenderFns } from "./StaticText.vue?vue&type=template&id=dc60e058&"
import script from "./StaticText.vue?vue&type=script&lang=js&"
export * from "./StaticText.vue?vue&type=script&lang=js&"
import style0 from "./StaticText.vue?vue&type=style&index=0&id=dc60e058&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports